import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BootOpenFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M19.9999 8.61938L19.1869 8.15934C18.2418 7.57298 17.1594 7.26243 16.0551 7.26243L11.7599 7.26338C11.3368 7.28358 10.9184 7.35665 10.5137 7.48043L6.44309 5.14026L6.23479 5.02051H5.99453H2.65991V6.82051H5.75426L8.40212 8.34274L3.99374 10.2029V15.4949L6.55076 16.6564C7.54321 19.975 11.4679 19.7444 12.465 17.1533H19.9999V8.61938Z"
      />
    </SvgIcon>
  );
});
